import { render, staticRenderFns } from "./liveItemPdfComponent.vue?vue&type=template&id=5da6cd21&scoped=true&"
import script from "./liveItemPdfComponent.vue?vue&type=script&lang=ts&"
export * from "./liveItemPdfComponent.vue?vue&type=script&lang=ts&"
import style0 from "./liveItemPdfComponent.vue?vue&type=style&index=0&id=5da6cd21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da6cd21",
  null
  
)

export default component.exports